<script setup>
const props = defineProps({
    items: {
        type: Array,
        default: []
    },
    label: {
        type: String,
        default: ''
    },
    initialValue: {
        type: Array,
        default: null
    }
})

const emits = defineEmits(['updateFilter'])

const updateFilter = (values) => {
    const valuesS = values.length ? values.map((item) => item.id) : []
    emits('updateFilter', valuesS)
}

const filterValues = ref([])

onMounted(() => {
    if (props.initialValue) {
        filterValues.value = props.items.filter((item) => {
            return [...props.initialValue].includes(`${item.id}`)
        })
    }
})
</script>
<template>
    <div class="single-filter-ui d-flex">
        <v-combobox
            v-model="filterValues"
            chips
            multiple
            :label="label"
            :items="items"
            item-title="name"
            @update:modelValue="updateFilter($event)"
        ></v-combobox>
    </div>
</template>
